"use client"
import unemploymentDataset from '@/data/unemployment.json'
import { WelfareRow, WelfareRowTable } from './WelfareIndicators'

type UnemploymentPoint = (typeof unemploymentDataset.points)[number]

const unemploymentTimelinePoints = unemploymentDataset.points as UnemploymentPoint[]

const formatTimelineDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
}

export const getUnemploymentForDate = (currentDate: Date) => {
  const currentTime = currentDate.getTime()
  const firstPoint = unemploymentTimelinePoints[0]
if (currentTime <= new Date(firstPoint.date).getTime()) {
    return {
      rate: firstPoint.rate,
      lowerPoint: firstPoint,
      upperPoint: firstPoint,
    }
  }

  const unemploymentTimelineSegments = unemploymentTimelinePoints.slice(0, -1)
  for (const [pointIndex, lowerPoint] of unemploymentTimelineSegments.entries()) {
    const upperPoint = unemploymentTimelinePoints[pointIndex + 1]
    const lowerTime = new Date(lowerPoint.date).getTime()
    const upperTime = new Date(upperPoint.date).getTime()
    if (currentTime <= upperTime) {
      const segmentProgress = (currentTime - lowerTime) / (upperTime - lowerTime)
      const rate = lowerPoint.rate + ((upperPoint.rate - lowerPoint.rate) * segmentProgress)
      return {
        rate: Math.round(rate * 10) / 10,
        lowerPoint,
        upperPoint,
      }
    }
  }

  const lastPoint = unemploymentTimelinePoints[unemploymentTimelinePoints.length - 1]
  return {
    rate: lastPoint.rate,
    lowerPoint: lastPoint,
    upperPoint: lastPoint,
  }
}

export const UnemploymentIndicators = ({
  currentDate,
  textColor,
}: {
  currentDate: Date
  textColor: string
}) => {
  const { rate, lowerPoint, upperPoint } = getUnemploymentForDate(currentDate)
  const tooltip = `Labor force participation rate (${formatTimelineDate(lowerPoint.date)} to ${formatTimelineDate(upperPoint.date)}). Story estimate from Plan A spreadsheet.`

  return (
    <WelfareRowTable
      label="Employment Rate"
      value={rate}
      max={100}
      format="percent"
      tooltip={tooltip}
      textColor={textColor}
    />
  )
}
